module.exports = __webpack_public_path__ + "img/overview-bottom.28866132.png";